/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pagination[_ngcontent-%COMP%]{list-style:none}.pagination[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#8cc63f;text-decoration:none}.pagination[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]{font-weight:bolder;text-decoration:underline;width:20px;height:20px;background:#8cc63f;color:#fff;text-align:center}.pagination[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff}.pagination[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none;opacity:.5}"];
export { styles as styles };
